import { BasePage } from '@/components/ui/base-page'

export function CommunityPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add CommunityPage specific content here */}
    </BasePage>
  )
}